import type { ActivityOverviewResponse, ActivityOverviewStatusFilter } from '@sparkapp/shared-types';
import { apiRequest } from './apiClient';

type Envelope<T> = { success: true; data: T };

export const activityOverviewApi = {
  async getOverview(status: ActivityOverviewStatusFilter): Promise<ActivityOverviewResponse> {
    return (await apiRequest<Envelope<ActivityOverviewResponse>>(`/v2/admin/activity-overview?status=${status}`)).data;
  },
};
